import { render } from "./Control.vue?vue&type=template&id=3883a27f"
import script from "./Control.vue?vue&type=script&lang=js"
export * from "./Control.vue?vue&type=script&lang=js"

import "./Control.vue?vue&type=style&index=0&id=3883a27f&lang=scss"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__